import { makeStyles, TableRow } from '@material-ui/core';
import React from 'react';

export function TableRowElement({ children }: { children?: React.ReactNode }): React.ReactElement {
  const classes = useStyles();
  return <TableRow className={classes.root}>{children}</TableRow>;
}

const useStyles = makeStyles((theme) => ({
  root: {
    '&>*': {
      borderRight: '1px solid #c0c0d2',
    },
    '&>*:last-child': {
      borderRight: 'none',
    },
  },
}));
